<template>
  <section
    class="login"
    @keyup.enter="requestResetCode">
    <router-link
      :to="{ name: 'LoginPage' }"
      class="pointer"
      tag="span">
      <img
        class="login__logo show-hand"
        style="display: inline-block !important;"
        src="~@/assets/img/SB-Images/app-logo.svg"
        alt="AI Number" >
    </router-link>

    <h1>Reset your password</h1>
    <div class="login-additionals">
      <span>Enter your email address below and we'll send you a link to reset your password.</span>
    </div>
    <ValidationObserver
      ref="customFieldObserver"
      v-slot="{ valid, pristine }" >
      <div class="login-form">
        <div class="login-form__step-one">
          <!-- email form field -->
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            name="Email" >
            <b-form-group
              label="Email"
              label-for="email">
              <b-form-input
                id="email"
                v-model="email"
                name="email"
                type="email"
                autocomplete="off"
                class="sb2-bordered sb2-hoverable sb2-focusable"
                placeholder="Enter your email"
                trim />
              <!-- email validation -->
              <div
                v-if="errors[0]"
                class="error flex flex-align-center">
                <SBIcon
                  class="mr-2"
                  :icon="SBIconList.ERROR"
                  :color="SBColors.redPrimary"
                  :size="12" />
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>
        </div>

        <!-- Login error message -->
        <span
          v-if="errorMessage && errorMessage.length"
          class="main-error flex center-all">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errorMessage }}</span>
        </span>

        <b-button
          variant="primary"
          :disabled="sending || !valid || pristine"
          :class="{loading: sending}"
          class="flex center-all settings__actions--save"
          block
          @click="requestResetCode">
          <span>Send reset instructions</span>
          <Spinner
            v-if="sending"
            :size="16"
            :thickness="2"
            :color="SBColors.white" />
        </b-button>
      </div>

      <div class="small-sub text-center">
        <span>Return to </span>
        <router-link
          :to="{ name: 'LoginPage' }"
          tag="span"
          class="login__forgot-pass">
          Sign in
        </router-link>
      </div>
    </ValidationObserver>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { extend } from 'vee-validate';
import { email } from 'vee-validate/dist/rules';
import setValidationErrors from '@/helpers/validationErrors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import Spinner from '@/components/common/Spinner';

extend('email', email);

export default {
  name: 'ResetPasswordRequest',
  components: {
    SBIcon,
    Spinner,
  },
  data() {
    return {
      email: '',
      sending: false,
      errorMessage: '',
      validationErrors: {},
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      passwordResetSent: 'user/passwordResetSent',
      apiError: 'user/apiError',
    }),
  },
  watch: {
    passwordResetSent(sent) {
      if (sent) {
        this.sending = false;
        this.$router.push({ name: 'ResetPasswordSent', params: { email: this.email } });
      }
    },
    apiError(error) {
      this.sending = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  beforeMount() {
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      resetPasswordRequest: 'user/resetPasswordRequest',
      finalizeSplashView: 'organisation/finalizeSplashView',
    }),
    requestResetCode() {
      this.errorMessage = '';
      this.validationErrors = {};
      if (this.$refs.customFieldObserver.flags.valid) {
        this.sending = true;
        this.resetPasswordRequest({
          email: this.email,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.settings__actions--save {
  margin-top: 30px;
  height: 44px;
}

.small-sub {
  margin-top: 16px;
  font-size: 14px !important;
  font-weight: 400 !important;
  color: $blackUltralight !important;
}
</style>
